module.exports = __webpack_public_path__ + "static/media/investment_head_bg.06b86a92.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/investment_head_bg.png
// module id = 1899
// module chunks = 0 1